/**
 * The app's toast styling (glassmorphic), shared by `main.tsx`'s Toaster and the preview harness's
 * toast page, so a reviewed toast is the toast the app shows.
 */
export const toastOptions = {
  duration: 4000,
  style: {
    background: 'rgba(15, 23, 42, 0.8)',
    backdropFilter: 'blur(20px)',
    border: '1px solid rgba(255, 255, 255, 0.12)',
    borderRadius: '12px',
    color: '#f1f5f9',
    fontSize: '14px',
    fontWeight: '500',
  },
  success: {
    iconTheme: {
      primary: '#22c55e',
      secondary: '#ffffff',
    },
  },
  error: {
    iconTheme: {
      primary: '#ef4444',
      secondary: '#ffffff',
    },
  },
};
